"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ZoteroPublications;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _extend2 = _interopRequireDefault(require("lodash/extend"));

var _includes2 = _interopRequireDefault(require("lodash/includes"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _api = require("./api");

var _data = _interopRequireDefault(require("./data"));

var _domWrapper = _interopRequireDefault(require("./dom-wrapper"));

var _renderer = _interopRequireDefault(require("./renderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Application entry point. Alternatively can be used as a convenience function to render publications
 * into a container
 * @param {*} [configOruserIdOrendpointOrData] - Configuration object that will selectively override
 *                                             the defaults. Alternatively if used as a convenience function,
 *                                             this is first argument (userIdOrendpointOrData) passed over to
 *                                             ZoteroPublications.render.
 * @param {*} [container] - Only when used as a convenience function, specifies a DOM element where publications
 *                        will be rendered
 * @param {*} [config] - Only when used as a convience function, configuration object that will selectively override
 *                     the defaults
 */
function ZoteroPublications() {
  var _this = this;

  if (arguments.length > 3) {
    return Promise.reject(new Error("ZoteroPublications takes between one and three arguments. ".concat(arguments.length, " is too many.")));
  }

  if (arguments.length <= 1) {
    this.config = (0, _extend2.default)({}, this.defaults, arguments ? arguments[0] : {});
  } else {
    this.config = (0, _extend2.default)({}, this.defaults, arguments[2]);
  }

  if (this.config.useCitationStyle && !(0, _includes2.default)(this.config.include, 'citation')) {
    this.config.getQueryParamsDefault.include.push('citation');
  }

  (0, _extend2.default)(this.config.getQueryParamsDefault, {
    style: this.config.citationStyle
  });
  this.ready = new Promise(function (resolve) {
    if (typeof document !== 'undefined' && document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        resolve();
      });
    } else {
      resolve();
    }
  });
  this.ready.then(function () {
    _this.config.zorgIntegration = _this.config.zorgIntegration && typeof Zotero !== 'undefined' ? Zotero.config && Zotero.config.loggedInUser || Zotero.currentUser : false;

    if (_this.config.zorgIntegration) {
      _this.config.zorgIntegration['apiKey'] = Zotero.config.apiKey;
    }
  });

  if (arguments.length > 1) {
    return this.render(arguments[0], arguments[1]);
  }
}
/**
 * Default configuration object
 * @type {Object}
 */


ZoteroPublications.prototype.defaults = {
  apiBase: 'api.zotero.org',
  citationStyle: '',
  storeCitationPreference: false,
  group: false,
  useCitationStyle: false,
  showBranding: true,
  useHistory: true,
  expand: 'all',
  zorgIntegration: false,
  authorsListed: 10,
  citeStyleOptions: {
    'american-anthropological-association': 'American Anthropological Association',
    'apa': 'American Psychological Association 6th edition',
    'cell': 'Cell',
    'chicago-author-date': 'Chicago Manual of Style 16th edition (author-date)',
    'chicago-fullnote-bibliography': 'Chicago Manual of Style 16th edition (full note)',
    'chicago-note-bibliography': 'Chicago Manual of Style 16th edition (note)',
    'harvard-cite-them-right': 'Harvard - Cite Them Right 9th edition',
    'ieee': 'IEEE',
    'modern-humanities-research-association': 'Modern Humanities Research Association 3rd edition (note with bibliography)',
    'modern-language-association': 'Modern Language Association 7th edition',
    'nature': 'Nature',
    'vancouver': 'Vancouver'
  },
  citeStyleOptionDefault: 'chicago-note-bibliography',
  exportFormats: {
    'bibtex': {
      name: 'BibTeX',
      contentType: 'application/x-bibtex',
      extension: 'bib'
    },
    'ris': {
      name: 'RIS',
      contentType: 'application/x-research-info-systems',
      extension: 'ris'
    },
    'rdf_zotero': {
      name: 'Zotero RDF',
      contentType: 'application/rdf+xml',
      extension: 'rdf'
    }
  },
  getQueryParamsDefault: {
    linkwrap: '1',
    order: 'date',
    sort: 'desc',
    start: '0',
    include: ['data'],
    limit: 100
  }
};
/**
 * Low-level function to fetch given url to obtain Zotero Data
 * @param  {String} url      - A Zotero API url to get
 * @param  {?Object} options - Settings that can complement or override instance config
 * @param  {?Object} init    - Options forwarded to the fetch method
 * @return {Promise}         - Resolved with ZoteroData object on success, rejected
 *                             in case of any network/response problems
 */

ZoteroPublications.prototype.get = function (url) {
  var _this2 = this;

  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var init = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  params = (0, _extend2.default)({}, this.config.getQueryParamsDefault, params);
  init = (0, _extend2.default)({
    headers: {
      'Accept': 'application/json'
    }
  }, init);

  if (params.include instanceof Array) {
    params.include = params.include.join(',');
  }

  var queryParams = (0, _map2.default)(params, function (value, key) {
    return "".concat(key, "=").concat(value);
  }).join('&');
  url = "".concat(url, "?").concat(queryParams);
  return new Promise(function (resolve, reject) {
    (0, _api.fetchUntilExhausted)(url, init).then(function (responseJson) {
      var data = new _data.default(responseJson, _this2.config);
      resolve(data);
    }).catch(reject);
  });
};
/**
 * Lol-level function to post data to given url
 * @param  {String} url 		- target url for the post request
 * @param  {[type]} data 		- Raw data posted as part of the request
 * @param  {?Object} params 	- Optional additional query string params
 * @param  {?Object} init 		- Options forwarded to the fetch method
 * @return {Promise} 			- Fetch promise
 */


ZoteroPublications.prototype.post = function (url, data) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var init = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var queryParams = (0, _map2.default)(params, function (value, key) {
    return "".concat(key, "=").concat(value);
  }).join('&');
  init = (0, _extend2.default)({
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }, init);
  url = "".concat(url, "?").concat(queryParams);
  return fetch(url, init);
};
/**
 * Build url for an endpoint then fetch entire dataset recursively
 * @param  {String} endpoint 	- An API endpoint from which data should be obtained
 * @param  {?Object} params 	- Optional additional query string params
 * @return {Promise} 			- Resolved with ZoteroData object on success, rejected
 *                        		in case of any network/response problems
 */


ZoteroPublications.prototype.getEndpoint = function (endpoint) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var apiBase = this.config.apiBase,
      url = "https://".concat(apiBase, "/").concat(endpoint);
  return this.get(url, params);
};
/**
 * Build url for an endpoint and use it to post data
 * @param  {String} endpoint 	- An API endpoint
 * @param  {[type]} data 		- Raw data posted as part of the request
 * @param  {?Object} params 	- Optional additional query string params
 * @return {Promise} 			- Fetch promise
 */


ZoteroPublications.prototype.postEndpoint = function (endpoint, data) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var apiBase = this.config.apiBase,
      url = "https://".concat(apiBase, "/").concat(endpoint);
  return this.post(url, data, params);
};
/**
 * Build url for getting user's publications then fetch entire dataset recursively
 * @param  {Number} userId 		- User id
 * @param  {?Object} params 	- Optional additional query string params
 * @return {Promise} 			- Resolved with ZoteroData object on success, rejected
 *                        		in case of any network/response problems
 */


ZoteroPublications.prototype.getPublications = function (userId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  this.userId = userId;
  return this.getEndpoint("users/".concat(userId, "/publications/items"), params);
};
/**
 * Build url for getting a single item from user's publications then fetch it
 * @param  {String} itemId 		- Item key
 * @param  {Number} userId 		- User id
 * @param  {?Object} params 	- Optional additional query string params
 * @return {Promise}			- Resolved with ZoteroData object on success, rejected
 *                       		in case of any network/response problems
 */


ZoteroPublications.prototype.getPublication = function (itemId, userId) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return this.getEndpoint("users/".concat(userId, "/publications/items/").concat(itemId), params);
};
/**
 * Build url for sending one or more items to user's library then post it
 * @param  {Number} userId 		- User id
 * @param  {Object} data 		- Raw data posted as part of the request
 * @param  {?Object} params 	- Optional additional query string params
 * @return {Promise} 			- Fetch promise
 */


ZoteroPublications.prototype.postItems = function (userId, data) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return this.postEndpoint("users/".concat(userId, "/items"), data, params);
};
/**
 * Render local or remote items.
 * @param  {String|ZoteroData} endpointOrData - Data containung publications to be rendered
 * @param  {HTMLElement} container            - A DOM element where publications will be rendered
 * @return {Promise}                          - Resolved when rendered or rejected on error.
 *                                              In browser, resolved with reference to the domwrapper instance
 *                                              In node, resolved with produced html {String}
 */


ZoteroPublications.prototype.render = function (userIdOrendpointOrData, container) {
  var _this3 = this;

  return new Promise(function (resolve, reject) {
    var promise;

    if (typeof window !== 'undefined' && !(container instanceof HTMLElement)) {
      reject(new Error('Second argument to render() method must be a DOM element'));
    }

    if (userIdOrendpointOrData instanceof _data.default) {
      promise = Promise.resolve(userIdOrendpointOrData);
    } else if (typeof userIdOrendpointOrData === 'number') {
      promise = _this3.getPublications(userIdOrendpointOrData);
    } else if (typeof userIdOrendpointOrData === 'string') {
      promise = _this3.getEndpoint(userIdOrendpointOrData);
    } else {
      reject(new Error('First argument to render() method must be an endpoint or an instance of ZoteroData'));
    }

    Promise.all([promise, _this3.ready]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          data = _ref2[0];

      if (_this3.config.group === 'type') {
        data.groupByType(_this3.config.expand);
      }

      if (typeof window !== 'undefined') {
        var domwrapper = new _domWrapper.default(container, _this3);
        domwrapper.displayPublications(data);

        if (_this3.config.useHistory && location.hash) {
          domwrapper.expandDetails(location.hash.substr(1));
        }

        resolve(domwrapper);
      } else {
        var renderer = new _renderer.default(_this3);

        if (data.grouped > 0) {
          resolve(renderer.renderGroupView(data));
        } else {
          resolve(renderer.renderPlainView(data));
        }
      }
    }).catch(reject);
  });
};
/**
 * Make ZoteroData publicly accessible underneath ZoteroPublications
 * @type {ZoteroData}
 */


ZoteroPublications.ZoteroData = _data.default;
/**
 * Make ZoteroRenderer publicly accessible underneath ZoteroPublications
 * @type {ZoteroRenderer}
 */

ZoteroPublications.Renderer = _renderer.default;
/**
 * Make DomWrapper publicly accessible underneath ZoteroPublications
 * but only if in browser environment
 * @type {DomWrapper}
 */

ZoteroPublications.DomWrapper = typeof window !== 'undefined' ? _domWrapper.default : null;